export enum WidgetManagerActionTypes {
  SelectWidgetDefinition = '[Widget Manager] Select Widget Definition',
  SetCurrentLayout = '[Widget Manager] Set Current Layout',
  SetCurrentLayoutIdentity = '[Widget Manager] Set Current Layout Identity',
  SetLayoutToLoad = '[Widget Manager] Set Layout To Load',
  SetLayoutKeys = '[Widget Manager] Set Layout Keys',
  ResetLayout = '[Widget Manager] Reset Layout',
  ResetWidgetManagerState = '[Widget Manager] Reset State',
}
